/** Desktop grid: 4 columns × 3 rows = 12 cards per page. */
export const CATALOG_PAGE_SIZE = 12;

export function catalogPageParams(page) {
	const pageNum = page ? page : 1;
	return {
		page: pageNum,
		page_size: CATALOG_PAGE_SIZE,
	};
}
